import Vue from "vue";
import { bus } from "@/main";

export default {
	props:[
		"source",
		"size",
		"muted",
		"poster",
		"controls",
		"loop",
	],
	data() {
		return {
			playing: false
		}
	},
	watch: {
		"playing": function() {
			bus.$emit("videoPlaying", this.playing)
		}
	},
	created() {
		// console.log("Source", this.source)
	},
	watch: {},
	methods: {
		videoAction(action) {
			bus.$emit("videoPlaying", this.playing)
			let video = this.$el.children[0]
			
			if(this.muted)
				video.muted = true

			if ( action == 'toggle' ) {
				if ( this.playing == true ) {
					video.pause();
					this.playing = false;
				} else {
					video.play();
					this.playing = true;
				}
			}

			if( action == 'play' ) {
				this.playing = true;
				video.play();
			}
			if( action == 'pause' ) {
				video.pause();
				this.playing = true;
			}
		},
	}
}


// WEBPACK FOOTER //
// ./src/components/blocks/video/video.block.js